import { render, staticRenderFns } from "./EntityCategoryUpsertDialog.vue?vue&type=template&id=0ad25f39"
import script from "./EntityCategoryUpsertDialog.vue?vue&type=script&lang=js"
export * from "./EntityCategoryUpsertDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports